<script lang="ts">
	import type { AvtaleFaq } from "#lib/types/avtale.js";
	import { PortableText } from "@portabletext/svelte";
	interface Props {
		faqs: AvtaleFaq;
	}

	let { faqs }: Props = $props();
</script>

<div class="mx-edge-x flex flex-col tablet:flex-row gap-4 py-6 mb-8 tablet:mb-11">
	<h2 class="basis-1/4 shrink-0 mb-0">{faqs.blockTitle}</h2>
	<div class="basis-3/4">
		<!-- <div class="basis-3/4 border-solid border-2 border-$fg rounded-$s-2 mt-2"> -->
		{#each faqs.faqs as faq (faq._key)}
			<details class="bg-[--primary-strong-10] rounded-xl py-2 px-3 my-3">
				<summary
					class="font-bold flex flex-row items-center justify-between list-none cursor-pointer"
				>
					{faq.question}
					<div
						class="shrink-0 w-8 h-8 rounded-full border-1 border-solid border-[--lysning] flex items-center justify-center bg-white"
					>
						<svg width="12" height="8" viewBox="0 0 12 8" fill="none">
							<path
								d="M1 1.5L6 6.5L11 1.5"
								stroke="var(--lysning)"
								stroke-width="2"
								stroke-linecap="round"
							/>
						</svg>
					</div>
				</summary>
				<PortableText value={faq.answer} />
			</details>
		{/each}
	</div>
</div>

<style>
	summary::-webkit-details-marker {
		content: "";
	}

	summary::marker {
		content: "";
	}
	details[open] summary div {
		transform: rotate(180deg);
	}
</style>
